export interface IItemCopyableObject {
  isSourceEmpty: boolean;
}

export function instanceOfIItemCopyableObject(instance: any): instance is IItemCopyableObject {
  return instance
      && (instance.isSourceEmpty !== undefined);
}
